"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var widgets_1 = require("@tableau/widgets");
exports.button = {
    marginRight: widgets_1.TabStyles.Spacing.MediumSpace,
};
//# sourceMappingURL=ClearButtonStyle.js.map